import { createEnsaioAnaliseApi } from "@/contexts/laboratorio/ensaioAnalise/api/ensaioAnaliseApi";
import { EnsaioAnalise } from "@/contexts/laboratorio/ensaioAnalise/model/EnsaioAnalise";
import { NaturezaAnalise } from "@/contexts/laboratorio/ensaioAnalise/model/NaturezaAnalise";
import {
  ensaioAnaliseAction,
  getEnsaiosAnaliseSynced,
} from "@/contexts/laboratorio/ensaioAnalise/store/ensaioAnaliseSlice";
import { SelectOption } from "@/shared/types/SelectOption";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useEnsaiosAnalise = () => {
  const { user } = useAuth();
  const ensaioAnaliseApi = createEnsaioAnaliseApi(user?.access_token);
  const listaEnsaios = useSelector(getEnsaiosAnaliseSynced);
  const appDispatch = useDispatch();
  const { sync } = ensaioAnaliseAction;
  const [ensaioOptions, setEnsaioOptions] = useState<SelectOption[]>([]);

  const sincronizarEnsaios = (ensaios: EnsaioAnalise[]) => {
    appDispatch(sync(ensaios));
  };

  const getEnsaiosApi = ensaioAnaliseApi.listAll;

  const getEnsaiosByNatureza = (natureza: NaturezaAnalise) => {
    const ensaios = listaEnsaios.filter(
      (ensaio) => ensaio.naturezaAnalise === natureza
    );
    const options = ensaios.map((ensaio) => ({
      label: `${(ensaio.nome ?? "").toUpperCase()} - ${ensaio.codigo}`,
      value: ensaio.id,
    }));
    setEnsaioOptions(options);
  };

  return {
    listaEnsaios,
    sincronizarEnsaios,
    getEnsaiosApi,
    ensaioOptions,
    getEnsaiosByNatureza,
  };
};
